// extracted by mini-css-extract-plugin
export default {"error":"VerifyLogin_error__Elw7I","resend":"VerifyLogin_resend__Bgkbb"};